import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    DOCUMENT,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';
import {Router} from '@angular/router';

import {AimoFacetValue} from '../../../../model/product.model';
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {AimoCategoryService} from "../../../../service/category/aimo-category.service";
import {AimoProductFacetService} from "../../../../service/product/aimo-product-facet.service";

export const MAX_CATEGORY_FACETS = 10;

@Component({
    selector: 'aimo-product-category-facets',
    templateUrl: './aimo-product-category-facets.component.html',
    standalone: false
})
export class AimoProductCategoryFacetsComponent implements AfterViewInit, OnDestroy, OnChanges, OnInit {
    @Input()
    set values(values: AimoFacetValue[]) {
        this.allValues = values;
        this.setCategories();
    }

    @Input()
    set showAll(showAll: false) {
        this.showAllValues = showAll;
        this.setCategories();
    }


    @Input() link: string;
    @Input() parentCategoryId: string;
    @Input() lowestLevelSelected = true;
    @Output() showAllAction = new EventEmitter<boolean>();

    categoryName: string;
    categoryCount: number;
    categories$: BehaviorSubject<AimoFacetValue[]> = new BehaviorSubject<AimoFacetValue[]>([]);
    allValues: AimoFacetValue[];
    showAllValues = false;
    subscriptions: Subscription = new Subscription();
    isMobileUi: boolean;

    @ViewChildren(NgbPopover) popovers!: QueryList<NgbPopover>;
    addedPopOvers = []

    ngAfterViewInit(): void {
        this.categoryService.closePopovers(this.popovers, this.addedPopOvers, this.subscriptions);
    }

    ngOnInit(): void {
        this.isMobileUi = this.document.defaultView.window?.matchMedia('only screen and (max-width: 760px)').matches;
    }

    ngOnChanges(): void {
        if (!this.destroyed) {
            setTimeout(() => {
                this.ngAfterViewInit();
            }, 1000);
        }
    }

    destroyed = false;

    ngOnDestroy(): void {
        this.destroyed = true;
        this.subscriptions.unsubscribe();
    }

    constructor(protected router: Router,
                protected categoryService: AimoCategoryService,
                @Inject(DOCUMENT) protected document: Document,
                protected productFacetService: AimoProductFacetService,
                protected cdr: ChangeDetectorRef) {
    }

    setCategories(): void {
        this.categories$.next(this.showAllValues ? this.allValues : this.allValues?.slice(0, MAX_CATEGORY_FACETS));
    }

    toggleShowAll(): void {
        this.showAllValues = !this.showAllValues;
        this.setCategories();
        this.showAllAction.emit(this.showAllValues);
    }

    showToggle(length: number): boolean {
        return length > MAX_CATEGORY_FACETS;
    }

    openCategoryFacet(queryParameters: string, id: string, name: string, count: number, divCategories: HTMLDivElement): void {
        if (!this.lowestLevelSelected && this.isMobileUi && this.popovers.filter(pop => pop.popoverContext.parent.name === name && pop.isOpen()).length === 0) {
            return;
        }
        this.categoryName = name;
        this.categoryCount = count;
        this.cdr.detectChanges();
        this.router.navigate([this.link], {
            queryParams: {query: queryParameters, parentCategory: id},
            //   fragment: 'category-content-anchor'
        });
        this.productFacetService.setScrollPosition(this.document.defaultView.window.pageYOffset);
        divCategories.focus();
    }

    protected toggle(subCategory: AimoFacetValue): void {
        subCategory.selected = !subCategory.selected;
    }


    getCategory(query: string): Observable<AimoFacetValue[]> {
        return this.categoryService.getCategory(query);
    }

    protected generateCategoryQuery(facet: AimoFacetValue): any {
        const query = facet.query.query.value;
        if (!query.includes('categoryLevel2')) {
            return query + ':categoryLevel2:' + facet.code;
        }
        return query;
    }

    private openTimeoutId: any;

    openPopup(popover: NgbPopover) {
        if (this.isMobileUi) {
            return;
        }
        // Set a delayed open action (e.g., 500ms)
        this.openTimeoutId = setTimeout(() => {
            if (!popover.isOpen()) {
                this.openTimeoutId = null;
                popover.open();
            }
        }, 1000);
    }

    clearPopupTimeout(popover: NgbPopover) {
        if (this.openTimeoutId && !this.isMobileUi) {
            clearTimeout(this.openTimeoutId);
            this.openTimeoutId = null;
        }
    }

    @HostListener('document:click', ['$event'])
    closePopups(event) {
        if (event.target.classList.contains('category')) {
            return;
        }
        this.popovers.forEach((popover) => {
            popover.close();
        });
    }
}
